import btn from '../styles/btn.js';
import { button } from '../styles/elements/button.js';

const btnReset = {
  ...button,
  ...btn.button,
  overflowX: 'visible',
  overflowY: 'visible',
  whiteSpace: 'normal',
  '&:hover': {
    background: 'inherit'
  },
  '&:active': {
    background: 'inherit'
  }
};
var btnReset$1 = btnReset;

export { btnReset$1 as default };
